var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrowFilled({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6875 1.08105L10.3877 1.88086L10.7168 2.25781L10.3408 2.58691L5.08398 7.17969H18.0215V9.24023H5.08594L10.3398 13.8232L10.7178 14.1523L10.3877 14.5293L9.6875 15.3291L9.35938 15.7051L8.9834 15.377L1.19336 8.58691L0.760742 8.20996L1.19238 7.83301L8.98242 1.0332L9.35938 0.705078L9.6875 1.08105Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowFilled);
export default __webpack_public_path__ + "static/media/back-arrow-filled.a4cdef937c83de9fa976035301a6b03d.svg";
export { ForwardRef as ReactComponent };